import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type {
  InitializeTrainerSessionRequest,
  SaveTrainerResponseRequest,
  TrainerProgressResponse,
  TrainerSessionStatisticsResponse,
  TrainerSessionResponse,
} from '@thiememeulenhoff/thor-client';
import { TrainerEndpointsService } from './trainer.endpoints.service';

@Injectable({
  providedIn: 'root',
})
export class TrainerService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(TrainerEndpointsService);

  initializeSession(payload: InitializeTrainerSessionRequest) {
    const endpoint = this.#endpoints.session();

    return this.#http.post<TrainerSessionResponse>(endpoint, payload);
  }

  submitResponse(payload: SaveTrainerResponseRequest) {
    const endpoint = this.#endpoints.response();

    return this.#http.post<TrainerProgressResponse>(endpoint, payload);
  }

  finishSession(sessionId: string) {
    const endpoint = this.#endpoints.finish(sessionId);

    return this.#http.get<TrainerSessionStatisticsResponse>(endpoint);
  }
}
